<template>
    <div>

        <modal
                class="abtg-modal"
                :width="800"
                height="auto"
                style="  overflow-y: auto;"
                name="m-auction">
            <div class="modal-dialog modal-lg abtg-modal-dialog" role="document">

                <form @submit.prevent="onSubmit()">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title abtg__modal-title">ASTA</h5>

                            <div class="tools">
                                <div class="abtg__close-button"><a @click="closeModal()"><i
                                        class="fas fa-times"></i></a></div>
                            </div>
                        </div>

                        <div class="modal-body">

                            <div class="row ">

                                <div class="col">
                                    <!-- EDIT MODE -->

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select getmdl-select__fix-height select-width abtg-select"
                                    >

                                        <label for="region_id"
                                               class=" abtg__label-select">{{$t('auction.label_region')}}</label>
                                        <select class="mdl-textfield__input abtg__input abtg-select" tabIndex="-1"
                                                id="region_id"
                                                v-model="content.formData.regione"
                                                @change="cityListByRegion({region: content.formData.regione})"
                                        >
                                            <option :value="region.regione" v-for="region in content.regionData">
                                                {{CHANGE_REGION_NAME(region.regione)}}
                                            </option>
                                        </select>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.region_id">
                                            {{content.myError.city_id[0]}}</p>
                                    </div>


                                </div>


                                <div class="col" v-if="content.regionData && content.regionData.length > 0 ">


                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select getmdl-select__fix-height select-width abtg-select"
                                    >
                                        <label for="city_id"
                                               class=" abtg__label-select">{{$t('auction.label_city')}}</label>
                                        <select class="mdl-textfield__input abtg__input abtg-select" tabIndex="-1"
                                                id="city_id"
                                                v-if="content.cityData"
                                                v-model="content.formData.city_id"

                                        >
                                            <option :value="city.id" v-for="city in content.cityData"
                                            >
                                                {{city.comune}}
                                            </option>
                                        </select>

                                        <p class="text-danger small" v-if="content.myError && content.myError.city_id">
                                            {{content.myError.city_id[0]}}</p>
                                    </div>


                                </div>

                                <div class="col">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                         style="margin-top:-20px;">

                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.indirizzo"

                                        >

                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_address')}}</label>
                                        <p class="text-danger small" v-if="content.myError && content.myError.address">
                                            {{content.myError.address[0]}}</p>


                                    </div>
                                </div>
                            </div> <!-- // row abtg-row-narrow -->


                            <div class="row abtg-row-narrow">
                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.rge">
                                        <label class="mdl-textfield__label abtg__margin-input ">{{$t('auction.label_rge')}}</label>
                                        <p class="text-danger small" v-if="content.myError && content.myError.rge">
                                            {{content.myError.rge[0]}}</p>
                                    </div>


                                </div>


                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.valore_ctu"

                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_ctu')}}</label>
                                        <p class="text-danger small" v-if="content.myError && content.myError.ctu">
                                            {{content.myError.ctu[0]}}</p>
                                    </div>


                                </div>

                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.mq">
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_mq')}}</label>
                                        <p class="text-danger small" v-if="content.myError && content.myError.mq">
                                            {{content.myError.mq[0]}}</p>
                                    </div>


                                </div>

                            </div> <!-- // row abtg-row-narrow -->


                            <div class="row abtg-row-narrow">
                                <div class="col">


                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.n_incanto">
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_tender')}}</label>
                                        <p class="text-danger small" v-if="content.myError && content.myError.tender">
                                            {{content.myError.tender[0]}}</p>
                                    </div>


                                </div>
                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.base_asta"
                                               >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_auction_base')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.base_asta">
                                            {{content.myError.base_asta[0]}}</p>
                                    </div>


                                </div>
                                <div class="col">


                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.offerta_minima"

                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_minimum_offer')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.minimum_offer">
                                            {{content.myError.minimum_offer[0]}}</p>
                                    </div>


                                </div>
                            </div> <!-- // row abtg-row-narrow -->


                            <div class="row abtg-row-narrow">
                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.rendita_catastale"

                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_cadastral_income')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.rendita_catastale">
                                            {{content.myError.rendita_catastale[0]}}</p>
                                    </div>

                                </div>

                                <div class="col">


                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >


                                      <input type="date"   v-model="content.formData.data_asta" class="form-control mt-1">

                                        <label class="mdl-textfield__label  " style="margin-top:-20px;">Data</label>


                                        <p class="text-danger small" v-if="content.myError && content.myError.data_asta"
                                           style="margin-top:30px;">
                                            {{content.myError.data_asta[0]}}</p>
                                    </div>


                                </div>

                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.reg_urbanistica">
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_city_planning')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.reg_urbanistica">
                                            {{content.myError.reg_urbanistica[0]}}</p>
                                    </div>


                                </div>
                            </div> <!-- // row abtg-row-narrow -->


                            <div class="row abtg-row-narrow">
                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.n_creditori">
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_creditors')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.n_creditori">
                                            {{content.myError.n_creditori[0]}}</p>
                                    </div>


                                </div>
                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.stato_occupazionale">
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_occupancy_status')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.stato_occupazionale">
                                            {{content.myError.stato_occupazionale[0]}}</p>
                                    </div>


                                </div>
                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.valore_immobiliare_it"

                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_building_value')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.valore_immobiliare_it">
                                            {{content.myError.valore_immobiliare_it[0]}}</p>
                                    </div>


                                </div>
                            </div> <!-- // row abtg-row-narrow-->


                            <div class="row abtg-row-narrow">
                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.valore_borsino_immobiliare"

                                        >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_borsino_value')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.valore_borsino_immobiliare">
                                            {{content.myError.valore_borsino_immobiliare[0]}}</p>
                                    </div>


                                </div>
                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.street_price"
                                               >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_street_price')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.street_price">
                                            {{content.myError.street_price[0]}}</p>
                                    </div>


                                </div>

                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.street_price_asta"
                                               >
                                        <label class="mdl-textfield__label abtg__margin-input">Street Price Questo Immobile</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.street_price_asta">
                                            {{content.myError.street_price_asta[0]}}</p>
                                    </div>


                                </div>

                            </div> <!-- // row abtg-row-narrow -->


                            <div class="row abtg-row-narrow">
                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.agenzia_1"
                                               >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_agency_1')}}</label>
                                        <p class="text-danger small" v-if="content.myError && content.myError.agency_1">
                                            {{content.myError.agenzia_1[0]}}</p>
                                    </div>


                                </div>

                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.agenzia_2"
                                               >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_agency_2')}}</label>
                                        <p class="text-danger small" v-if="content.myError && content.myError.agency_2">
                                            {{content.myError.agenzia_2[0]}}</p>
                                    </div>


                                </div>

                                <div class="col">

                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.agenzia_3"
                                               >
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_agency_3')}}</label>
                                        <p class="text-danger small" v-if="content.myError && content.myError.agency_3">
                                            {{content.myError.agenzia_3[0]}}</p>
                                    </div>

                                </div>
                            </div> <!-- // row abtg-row-narrow -->


                            <div class="row abtg-row-narrow ">
                                <div class="col">


                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.rialzo_minimo">
                                        <label class="mdl-textfield__label abtg__margin-input">Rialzo minimo</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.rialzo_minimo">
                                            {{content.myError.rialzo_minimo[0]}}</p>
                                    </div>


                                </div>
                                <div class="col">
                                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <input class="mdl-textfield__input abtg__input" type="text"
                                               v-model="content.formData.riferimenti_custode">
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_guardian')}}</label>
                                        <p class="text-danger small"
                                           v-if="content.myError && content.myError.riferimenti_custode">
                                            {{content.myError.riferimenti_custode[0]}}</p>
                                    </div>
                                </div>

                                <div class="col">

                                    <div style="max-width: 100%!important;"
                                         class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                                    >
                                        <textarea class="mdl-textfield__input abtg__input" type="text"
                                                  v-model="content.formData.note" rows="1"></textarea>
                                        <label class="mdl-textfield__label abtg__margin-input">{{$t('auction.label_note')}}</label>
                                        <p class="text-danger small" v-if="content.myError && content.myError.note">
                                            {{content.myError.note[0]}}</p>
                                    </div>


                                </div>
                            </div>
                            <div class="row abtg-row-narrow abtg-mb-20">
                                <div class="col-md-12" v-if="content.formData.link">

                                    <p>Link dell'annuncio: <a :href="content.formData.link" target="_blank">Portale
                                        Vendite
                                        Pubbliche</a></p>

                                </div>
                                <div class="col-md-4">


                                </div>
                            </div> <!-- // row abtg-row-narrow -->

                            <div class="row ">
                                <div class="col">

                                    <label class="mdl-textfield__label abtg__margin-input"
                                           style="margin-left:15px;margin-top: -30px;">{{$t('auction.label_excerpt')}}</label>
                                    <div style="margin-top:15px;">
                                        <div class="custom-radios">
                                            <div>
                                                <input type="checkbox" id="color-5" name="color"
                                                       v-model="content.formData.stralciabile"
                                                       :value="1"
                                                >
                                                <label for="color-5">
                                                    <span><i class="fas fa-check"></i></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">

                                    <label class="mdl-textfield__label abtg__margin-input"
                                           style="margin-top: -30px;margin-left: 15px;">{{$t('auction.label_choose_color')}}
                                    </label>
                                    <div style=" float:left;margin-left:90px;margin-top:-25px;">
                                        <n-popover module="auction" content="legend" position="top"></n-popover>
                                    </div>


                                    <div class="clearfix"></div>
                                    <div class="custom-radios">

                                        <div>
                                            <input type="radio" id="color-1" name="color"
                                                   v-model="content.formData.color"
                                                   :value="1"
                                            >
                                            <label for="color-1">
                                                <span><i class="fas fa-check"></i></span>
                                            </label>
                                        </div>

                                        <div>
                                            <input type="radio" id="color-2" name="color"
                                                   v-model="content.formData.color"
                                                   :value="2">
                                            <label for="color-2">
                                                <span><i class="fas fa-check"></i></span>
                                            </label>
                                        </div>

                                        <div>
                                            <input type="radio" id="color-3" name="color"
                                                   v-model="content.formData.color"
                                                   :value="3">
                                            <label for="color-3">
                                                <span><i class="fas fa-check"></i></span>
                                            </label>
                                        </div>

                                        <div>
                                            <input type="radio" id="color-4" name="color"
                                                   v-model="content.formData.color"
                                                   :value="4">
                                            <label for="color-4">
                                                <span><i class="fas fa-check"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                    <p class="text-danger small" v-if="content.myError && content.myError.color">
                                        {{content.myError.color[0]}}</p>

                                </div>
                            </div> <!-- // row abtg-row-narrow -->


                        </div>
                        <div class="modal-footer">

                            <button type="submit"
                                    class="margin-right-10 btn-success float-right abtg__btn-star"

                            >

                                SALVA
                            </button>


                        </div>


                    </div>
                </form>
            </div>
        </modal>
    </div>

</template>
<script>
    import {mixin} from '@/helpers/helper';
    import NPopover from '@/partials/popover';
    import DatePicker from "vue2-datepicker";
    import {mapActions} from 'vuex';

    export default {
        mixins: [mixin],
        props: ['content'],
        components: {DatePicker, NPopover},


        methods: {

          formatDate(rawDate) {
            const [month, day, year] = rawDate.split('-');
            return `${year}-${month}-${day}`;
          },

            closeModal() {
                this.$emit('closeModal', 'm-auction');
                let force = true;
                if(this.content.formData.id)
                {
                    force = null;
                }
                this.$emit('refreshPage', force)
            },
            onSubmit() {
                this.sendData();
                this.closeModal();
            },
            ...mapActions('n_auction', [  'sendData' , 'cityListByRegion']),
        }
    }
</script>
